module.exports = __webpack_public_path__ + "img/616-cover-bigger.f802deb4.png";